<div class="cart-container">
  @if (items().length > 0) {
    <div class="cart-content">
      <!-- Left Column: Cart Items -->
      <div class="cart-items-section">
        <h2 class="cart-title">
          {{ 'CART.yourCart' | translate }}
        </h2>
        <div class="shipping-info">
          <i class="pi pi-truck"></i>
          <span>Shipping ({{ items().length }} items)</span>
        </div>

        @if (warehouseCount() === 1) {
          <!-- Single warehouse layout -->
          <div class="items-list">
            @for (item of items(); track item.product_size_id; let i = $index) {
              <app-cart-item
                [item]="item"
                [removeIndex]="i"
                [inactive]="inactiveVariantIds().includes(item.product_variant_id)"
                [disablePrices]="disablePrices"
                [hidePrices]="hidePrices()"
                [isGifting]="isGifting()"
                (remove)="removeItem($event)"
                (quantityChange)="onQuantityChange($event.index, $event.value)"
              />
            } @empty {
              <p>{{ 'CART.noProductMessage' | translate }}.</p>
            }
          </div>
        } @else {
          <!-- Multiple warehouses layout -->
          @for (group of warehouseGroups(); track group.warehouseName; let groupIndex = $index) {
            <div class="parcel-section">
              <h3 class="parcel-title">{{ group.warehouseDisplayName }}</h3>
              <div class="items-list">
                @for (item of group.items; track item.product_size_id) {
                  <app-cart-item
                    [item]="item"
                    [removeIndex]="item.originalIndex"
                    [inactive]="inactiveVariantIds().includes(item.product_variant_id)"
                    [disablePrices]="disablePrices"
                    [hidePrices]="hidePrices()"
                    [isGifting]="isGifting()"
                    (remove)="removeItem($event)"
                    (quantityChange)="onQuantityChange($event.index, $event.value)"
                  />
                } @empty {
                  <p>{{ 'CART.noProductMessage' | translate }}.</p>
                }
              </div>
            </div>
          } @empty {
            <div>{{ 'CART.noProductMessage' | translate }}</div>
          }
        }
      </div>

      <!-- Right Column: Summary -->
      <div class="summary-section">
        <h2 class="summary-title">Summary</h2>
        <div class="summary-content">
          @if (!disablePrices && !hidePrices()) {
            <div class="summary-details">
              <div class="summary-line">
                <span class="summary-label">Subtotal</span>
                <span class="summary-value">{{ totalPrice() | price | usdPipe }}</span>
              </div>
              @if (giftCardBalance() > 0) {
                <div class="summary-line">
                  <span class="summary-label">Gift Card Balance</span>
                  <span class="summary-value discount">
                    -{{ giftCardBalance() | price | usdPipe }}
                  </span>
                </div>
                <div class="summary-divider"></div>
              }
              <div class="summary-line summary-total">
                <span class="summary-label">Total</span>
                <span class="summary-total-value">
                  {{ totalPriceWithGiftCard() | price | usdPipe }}
                </span>
              </div>
            </div>
            <div class="summary-divider"></div>
          }
          @if (!canCheckout) {
            <p class="mb-3">{{ 'POPUP_STORE.cartNotice' | translate }}</p>
          }
          <div class="checkout-button-wrapper">
            <app-button
              label="Checkout"
              [fullWidth]="true"
              [disabled]="hasInactiveItems() || !canCheckout"
              (handleClick)="goToCheckout()"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-empty-page [message]="'CART.emptyCart' | translate"></app-empty-page>
  }
</div>

<p-dialog
  header="Confirm Remove"
  [(visible)]="displayRemoveDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '400px' }"
>
  <div>
    <p>Are you sure you want to remove this item from the cart?</p>
  </div>
  <ng-template #footer>
    <div class="flex justify-content-end w-full">
      <div>
        <app-button
          type="button"
          label="Cancel"
          buttonStyle="outlined"
          (handleClick)="cancelRemove()"
        ></app-button>
      </div>
      <div>
        <app-button type="button" label="Confirm" (handleClick)="confirmRemove()"></app-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
